import React from 'react';
import { SectionHeading } from './SectionHeading';
const TEMPLE_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/576a32cd-f02a-4952-9378-6ee6a8d946fe.jpg';
export function Trajectory() {
  return <section aria-labelledby="templo-title" className="relative border-t border-silver/10 bg-indigo-deep py-20 sm:py-28" data-id="element-188" data-mp="1rk11lrae9wkk">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-189" data-mp="1wfzspmn3xsoo">
        <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-190" data-mp="yvn194vu2o5u">
          <div className="relative overflow-hidden rounded-2xl border border-silver/15 shadow-card" data-id="element-191" data-mp="13svi9258wm5i">
            <img src={TEMPLE_IMAGE} alt="Interior de un templo espiritual en penumbra con arcos de piedra, velas encendidas en candelabros de plata y un altar con cartas de tarot y amatistas" className="h-full w-full object-cover" loading="lazy" data-id="element-192" data-mp="18s86nrbrm1a7" />
            <div aria-hidden="true" className="absolute inset-0 bg-violet-deep/20 mix-blend-multiply" data-id="element-193" data-mp="l1vta0xr3cc8" />
          </div>

          <div data-id="element-194" data-mp="2hdhwce33tcdn">
            <SectionHeading id="templo-title" eyebrow="Trayectoria y experiencia" title="TEMPLO DE AYUDA" align="left" data-id="element-195" data-mp="2hcq2p8t2hoq0">
              <div className="space-y-5 text-[0.98rem] leading-relaxed text-silver sm:text-lg" data-id="element-196" data-mp="28l69t3b4292y">
                <p data-id="element-197" data-mp="23ljwktva8su5">
                  Ofrecemos consultas y prácticas espirituales tradicionales con
                  atención personalizada para personas interesadas en orientación
                  espiritual y rituales tradicionales.
                </p>
              </div>
            </SectionHeading>

            <dl className="mt-10 grid gap-px overflow-hidden rounded-xl border border-silver/15 bg-silver/10 sm:grid-cols-2" data-id="element-198" data-mp="1pmk3na0qlrs6">
              <div className="bg-carbon p-6" data-id="element-199" data-mp="3o0dfqkwml93y">
                <dt className="text-[0.68rem] font-medium uppercase tracking-[0.22em] text-silver/70" data-id="element-200" data-mp="3k03a59cqwkpm">
                  Consultas y rituales
                </dt>
                <dd className="mt-3 text-sm leading-relaxed text-silver" data-id="element-201" data-mp="1hbuz9e2z7838">
                  Consultas y prácticas espirituales realizadas de manera
                  personalizada.
                </dd>
              </div>
              <div className="bg-carbon p-6" data-id="element-202" data-mp="18an24zc74daq">
                <dt className="text-[0.68rem] font-medium uppercase tracking-[0.22em] text-silver/70" data-id="element-203" data-mp="1cdjpf3cokxl0">
                  Atención
                </dt>
                <dd className="mt-3 text-sm leading-relaxed text-silver" data-id="element-204" data-mp="201t29frx2b00">
                  Cada consulta se aborda según las circunstancias de cada
                  persona.
                </dd>
              </div>
            </dl>
          </div>
        </div>
      </div>
    </section>;
}